// @flow

import { hpfetch } from '../util';
import type {
  wantedSummaryType,
  wantedType,
  listingBubbleType,
} from '../../types';
import type {
  djangoModelApiResponse,
  wrappedApiResponseType,
} from '../apiTypes';
import { addInstanceType } from '../../library/hitchpin_card/hitchpinCardFunctions';
import { CardInstanceType } from '../../components/Shared/HitchpinCard/CardInstanceType';

export const getSingle = (
  id: number,
): Promise<wrappedApiResponseType<wantedType>> => hpfetch(`wanteds/${id}/`);

export const getMany = (
  limit: number = 100,
  offset: number = 0,
): djangoModelApiResponse<wantedType> =>
  hpfetch(`wanteds/?limit=${limit}&offset=${offset}`);

export const searchWantedSummary = (
  queryString: string,
): djangoModelApiResponse<wantedSummaryType> =>
  hpfetch(`wanteds/summary/?${queryString}`);

export const searchWantedSummaryBubbles = (
  queryString: string,
): Promise<wrappedApiResponseType<Array<listingBubbleType>>> =>
  hpfetch(`wanteds/summary_bubble/?${queryString}`);

export const getMatchesForWanted = (id: number, limit: number = 8) =>
  hpfetch(`wanteds/${id}/matches/?limit=${limit}`, {
    method: 'GET',
  }).then(response => addInstanceType(response, CardInstanceType.WantedMatch));

export const searchWanteds = (
  queryString: string,
): djangoModelApiResponse<wantedType> => hpfetch(`wanteds/?${queryString}`);

export const getMyWanteds = (limit: number = 100, offset: number = 0) =>
  hpfetch(`wanteds/mine/?limit=${limit}&offset=${offset}`);

export const createWanted = (fields: any) =>
  hpfetch('wanteds/', {
    method: 'POST',
    body: JSON.stringify(fields),
  });

export const updateWanted = (id: number, fields: any) =>
  hpfetch(`wanteds/${id}/`, {
    method: 'PATCH',
    body: JSON.stringify(fields),
  });

export const deleteWanted = (id: number) =>
  hpfetch(`wanteds/${id}/`, {
    method: 'DELETE',
  });

export const check = (id: number, hash: any) =>
  hpfetch(`wanteds/${id}/check/`, {
    method: 'POST',
    body: JSON.stringify({ hash }),
  });

export const similarListings = (id: number, queryString: string) =>
  hpfetch(`wanteds/${id}/similar/?${queryString}`, {
    method: 'GET',
  });
